import { render, staticRenderFns } from "./UserImportSummaryCard.vue?vue&type=template&id=76ca3c9e&"
import script from "./UserImportSummaryCard.vue?vue&type=script&lang=js&"
export * from "./UserImportSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports